import { render, staticRenderFns } from "./Metacom9LicenseAssistant.vue?vue&type=template&id=09ffd228&scoped=true&lang=pug"
import script from "./Metacom9LicenseAssistant.vue?vue&type=script&lang=js"
export * from "./Metacom9LicenseAssistant.vue?vue&type=script&lang=js"
import style0 from "./Metacom9LicenseAssistant.vue?vue&type=style&index=0&id=09ffd228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ffd228",
  null
  
)

export default component.exports